export default __webpack_public_path__ + "static/media/flag_pto.324e1a48.png";